/* eslint-disable tailwindcss/no-arbitrary-value */
import { Dialog as TailwindDialog, IconButton } from '@material-tailwind/react';
import { ReactElement } from 'react';
import { BaseTranslations } from '../../../baseTranslations';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { FeLink } from '../../FeLink';
import Close from '../../icons/Close';
import MessageIcon from '../../icons/Message';
import { WhatsAppButton } from './WhatsappButton';

type ConfirmationModalPops = {
  isOpen: boolean;
  onClose: () => void;
  waLink: string;
  pushDataLayer: PushDataLayerFn;
};

export function ConfirmationModal({
  isOpen,
  onClose,
  waLink,
  pushDataLayer,
}: ConfirmationModalPops): ReactElement<ConfirmationModalPops> {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  const handleWhatsAppButton = () => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'overlay',
      component_title: 'Confirmation Modal_WhatsApp us now',
      action: 'click',
    });
  };

  return (
    <TailwindDialog
      className="relative flex !w-82 items-center justify-center overflow-hidden rounded-lg p-4 md:!w-100 md:rounded-2xl lg:w-[800px] lg:rounded-3xl lg:p-6"
      open={isOpen}
      handler={onClose}
    >
      <div className="absolute right-6 top-6">
        <IconButton
          variant="text"
          className="flex size-6 items-center justify-center text-gray-900"
          onClick={onClose}
        >
          <Close className="flex size-6 text-gray-900" />
        </IconButton>
      </div>
      <div className="flex flex-col items-center gap-4 text-center lg:gap-6">
        <div className="mx-auto flex flex-col items-center gap-2 lg:gap-4 lg:pt-[13px]">
          <div className="flex size-16 items-center  justify-center rounded-full p-3 bg-fill/primary-light md:size-20 lg:size-24 lg:p-4">
            <MessageIcon className="size-16 fill-fill/primary-dark md:size-20 lg:size-24" />
          </div>
          <p className="w-full font-bold text-gray-900 text-xl md:text-2xl lg:w-103 lg:text-3xl">
            {staticText.confirmation_modal_title}
          </p>
          <p className="w-full font-medium text-[#424242] text-sm md:text-base lg:w-100 lg:text-lg">
            {staticText.confirmation_modal_subtitle}
          </p>
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-1 lg:w-100 lg:gap-2">
          <FeLink href={waLink} className="w-full">
            <WhatsAppButton
              text={staticText.WA}
              onClick={handleWhatsAppButton}
              trackClick={handleWhatsAppButton}
              className="h-9 w-full"
              type="button"
              iconSize={22}
            />
          </FeLink>
          <p className="font-medium text-gray-700 text-xs md:text-sm lg:text-base">
            {staticText.timing}
          </p>
        </div>
      </div>
    </TailwindDialog>
  );
}
